import { useQuery } from "@apollo/client";
import { gql } from "@/gql";

const VALIDATE_INVITATION_QUERY = gql(`
  query ValidateInvitation($token: String!) {
    validateInvitation(token: $token) {
      id
      email
      workerName
      salonName
      salonId
      status
      expiresAt
      isExpired
    }
  }
`);

export const useValidateInvitation = (token: string) => {
  const query = useQuery(VALIDATE_INVITATION_QUERY, {
    variables: { token },
    skip: !token,
  });

  return {
    invitation: query.data?.validateInvitation,
    loading: query.loading,
    error: query.error,
    refetch: query.refetch,
  };
};
